module.exports = __webpack_public_path__ + "JO.png?f344691625451dc007c5b85f1052a827";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/JO.png
// module id = 366
// module chunks = 0